module.exports = __webpack_public_path__ + "img/icon_gas_alert.svg";